let appConfig = null;

export const loadConfig = async () => {
  try {
    const response = await fetch('/config.json');
    appConfig = await response.json();
    if (process.env.NODE_ENV === 'development') {
      console.log('Client App Config loaded:', appConfig);
    }
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      console.error('Failed to load config, using defaults:', error);
    }
    appConfig = {
      API_BASE_URL: "https://localhost:7083/api/",
      CURRENCY: "PKR",
      MAIN_LABEL: "Back to the School",
      APP_TITLE: "Tone of Bike",
      APP_ICON: "logo192.png",
      SHOW_CONSOLE_LOG: true,
      TOP_TABLE: "Categories",
      FOOTER_ABOUT_TITLE: "About Us",
      FOOTER_ABOUT_TEXT: "we believe that every child deserves the best tools for both play and education. Our store is a one-stop destination for high-quality toys, school supplies, and learning essentials that inspire creativity, curiosity, and confidence in young minds.",
      FOOTER_MISSION: "Our mission is to build Some modifications, like custom frames, extended forks, and hard tail conversions, may require approval.",
      FOOTER_COMPANY: "Rangoon",
      FOOTER_LINKS: [
        { label: "Information", url: "/information" },
        { label: "FAQs", url: "/faqs" },
        { label: "Size Guide", url: "/size-guide" },
        { label: "Delivery Info", url: "/delivery-info" },
        { label: "Return Info", url: "/return-info" },
        { label: "Discount", url: "/discount" },
        { label: "Gift", url: "/gift" }
      ],
      FOOTER_CONTACT_TITLE: "CONTACT US",
      FOOTER_ADDRESS: "PO Box C17A3132 Collins Street West, Lahore Pakistan",
      FOOTER_PHONE: "+92 00 000 0000",
      FOOTER_FAX: "000 000 0000",
      FOOTER_EMAIL: "Rangoon@gmail.com",
      FOOTER_COPYRIGHT: "Copyright © by Flow Tech"
    };
  }
  return appConfig;
};

export const getConfig = () => appConfig?.client || appConfig; 